import { useTranslation } from 'react-i18next';
import { animated } from '@react-spring/web';

import { Button, LoadingSpinner, Paragraph, ScrollArea } from '@app/shared/ui/atoms/Common';
import { TopBar } from '@app/shared/ui/molecules/Common';
import { Modal } from '@app/shared/ui/organisms/Common';
import { PandaDateSelect } from '@app/shared/ui/organisms/CompatibilityCalc';
import { useCompatibilityCalculator } from '@app/shared/hooks/useCompatibilityCalculator';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { eatingPandaImage, COMPATIBILITY_PRELOAD_IMAGES } from '@app/assets';

export default function CompatibilityCalculatorPage() {
  const { t } = useTranslation();

  const {
    leftPandaSpring,
    rightPandaSpring,
    checkButtonSpring,
    userProgress,
    firstDate,
    setFirstDate,
    secondDate,
    setSecondDate,
    isUserProfileLoading,
    isUserProgressLoading,
    isResultModalOpen,
    handleCheckButtonClick,
    handleModalClose,
  } = useCompatibilityCalculator();
  const isImagesLoading = usePreloadImages(COMPATIBILITY_PRELOAD_IMAGES);

  if (isUserProfileLoading || isUserProgressLoading || isImagesLoading) {
    return <LoadingSpinner />;
  }

  const isCheckDisabled = !firstDate || !secondDate;

  return (
    <ScrollArea className="pb-16 pt-4">
      <TopBar translationKey="compatibility_calc.title" />

      <div className="relative flex h-full items-center justify-center">
        <div className="grid grid-cols-2 gap-4">
          <PandaDateSelect
            spring={leftPandaSpring}
            labelTranslationKey="compatibility_calc.your_birthday_label"
            date={firstDate}
            setDate={setFirstDate}
            pandaIcon={userProgress?.icon}
          />
          <PandaDateSelect
            spring={rightPandaSpring}
            labelTranslationKey="compatibility_calc.partner_birthday_label"
            date={secondDate}
            setDate={setSecondDate}
          />
        </div>
        <animated.div style={checkButtonSpring} className="absolute left-1/2 top-1/3">
          <Button
            shadow="cyan"
            className="min-h-[110px] w-20 min-w-[110px] -translate-x-1/2 rounded-full border-4 border-primary/80 text-shadow-dark disabled:border-accent/50 disabled:bg-secondary disabled:text-secondary-foreground/30 disabled:shadow-none disabled:text-shadow-none"
            disabled={isCheckDisabled}
            onClick={handleCheckButtonClick}
          >
            {t('compatibility_calc.check')}
          </Button>
        </animated.div>
      </div>

      {/*TODO: add an actual sentence and modal pictures when back is ready*/}
      <Modal
        isOpen={isResultModalOpen}
        onOpenChange={handleModalClose}
        hiddenTitle="compatibility result modal"
        featuredImg={
          <img src={eatingPandaImage} alt="eating-panda" className="h-full w-full object-contain" />
        }
      >
        <Paragraph variant="white">
          Вы с этим человеком как два камня из одного Храма. Вместе — вы можете построить Дом, где
          свет и принятие будут основой.
        </Paragraph>
      </Modal>
    </ScrollArea>
  );
}
